import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Projects from '../components/Projects';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const ProjectsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 bg-gradient-to-b from-teal-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Community Initiatives
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leading innovative projects for cancer prevention, early detection, and patient support
          </p>
        </div>
      </div>

      {/* Projects Content */}
      <Projects />

      {/* Vision & Mission */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="bg-teal-50 rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Vision</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                To make world-class cancer care accessible to all, with special focus on prevention, early detection, and comprehensive patient support throughout Northeast India.
              </p>
              <p className="text-gray-700 leading-relaxed">
                We believe that cancer care extends beyond medical treatment to include community education, screening programs, and holistic patient support systems.
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Research Goals</h2>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Prevention</h3>
                    <p className="text-gray-600">Community awareness and lifestyle modification programs</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Early Detection</h3>
                    <p className="text-gray-600">Screening initiatives and AI-powered detection methods</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Curable Malignancies</h3>
                    <p className="text-gray-600">Focus on cancers with high cure rates when detected early</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Palliative Care</h3>
                    <p className="text-gray-600">Quality of life improvement at all stages</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Get Involved */}
      <section className="py-20 px-4 bg-gradient-to-r from-teal-700 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">Want to Support Our Initiatives?</h2>
          <p className="text-xl mb-8 opacity-90">
            Join us in making a difference in cancer care and patient support
          </p>
          <Link to="/contact">
            <Button size="lg" variant="secondary" className="bg-white text-teal-700 hover:bg-gray-100 px-8 py-6 text-lg">
              Get in Touch
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProjectsPage;